export enum UserRoles {
  AccountOwner = 'AccountOwner',
  Admin = 'Admin',
  User = 'User',
  Support = 'Support',
  OrderManager = 'OrderManager',
  Staffer = 'Staffer',
  Owner = 'Owner',
  CS = 'CS',
  StaffManager = 'StaffManager',
  PartnerManager = 'PartnerManager',
  Waw = 'Waw',
  AuDelegationkeyManager = 'AuDelegationkeyManager',
  TransactionalTeam = 'Transactional Team',
  Consent2SmoothMigrator = 'Consent2SmoothMigrator',
  TrialDispenser = 'TrialDispenser',
}
